import React from "react";
import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";

const TableLLIField = ({
  element,
  childOpt,
  pageId,
  schemaItem,
  option,
  error,
  id,
  tdkeys,
  rowkeys,
  tableName,
  name,
  errorBorder,
  values,
  disabled,
  setChildOpt,
  setFieldValue,
  schemaPageFields,
  tableChildOpts,
}) => {
  // per-row map takes precedence over the legacy single-global childOpt
  const rowOptKey = `${tdkeys}_${schemaItem}`;
  const resolvedOptions =
    tableChildOpts && rowOptKey in tableChildOpts
      ? tableChildOpts[rowOptKey]
      : childOpt && childOpt.childPageId === pageId && childOpt.childItemId === schemaItem
      ? childOpt.optionsData
      : option;

  const handleChange = (e) => {
    const label = e.target.value;
    setFieldValue(`${tableName}[${tdkeys}].${name}`, label);

    // guard: childItemId 0/undefined would accidentally match unrelated fields
    if (element.childItemId) {
      const childEl = schemaPageFields?.find((x) => x.schemaItem === element.childItemId);
      if (childEl?.fieldName) {
        setFieldValue(`${tableName}[${tdkeys}].${childEl.fieldName}`, "");
      }

      if (setChildOpt) {
        const defaultOptions = childEl?.options || [];
        let optionsData = defaultOptions;
        if (label && element?.childLists) {
          const optionValue = (element.options || []).find((x) => x.label === label)?.value;
          if (optionValue != null) {
            optionsData = element.childLists[String(optionValue)] ?? defaultOptions;
          }
        }
        setChildOpt({
          childPageId: element.childPageId,
          childItemId: element.childItemId,
          tdkeys,
          optionsData,
        });
      }
    }
  };

  return (
    <div className="wrapper">
      <div className="form-field">
        <Field
          as="select"
          className={`tableInput ${errorBorder}`}
          id={id + tdkeys + 1}
          rowkeys={tdkeys}
          tdkeys={rowkeys}
          name={`${tableName}[${tdkeys}].${name}`}
          data-testid="TableSelectField"
          value={values?.[tableName]?.[tdkeys]?.[name] || ""}
          onChange={handleChange}
          disabled={disabled}
        >
          <option value=""></option>
          {resolvedOptions.map((i, index) => (
            <option key={index} value={element?.prefix === "LLI" ? i.label : i.value}>
              {i.label}
            </option>
          ))}
        </Field>
        {error?.[name] && (
          <span className="icon">
            <Tooltip title={error[name]}>
              <WarningIcon sx={{ color: pink[500] }} />
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
};

export default TableLLIField;
